import breakpointsFunc from '../breakpointsFunc';
const MuiContainer = {
  styleOverrides: {
    root: {
      [breakpointsFunc.breakpoints.up('xs')]: {
        paddingLeft: '0',
        paddingRight: '0'
      }
    }
  },
  variants: [{
    props: {
      variant: 'narrow'
    },
    style: {
      maxWidth: '1000px !important',
      width: '100%',
      margin: '0 auto',
      paddingTop: '40px'
    }
  }]
};
export default MuiContainer;